import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isNumeric(formValue: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: unknown } | null => {
        const numberReg = new RegExp('^-?\\d+$');
        return !numberReg.test(formValue.value)
            ? { invalidInputForType: { type: 'numeric', message: 'Value must be numeric' } }
            : null;
    };
}

export function dateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Allow empty values (use Validators.required separately if needed)
        if (!value) {
            return null;
        }

        const date = new Date(value);

        // Check if JavaScript's Date constructor returns an 'Invalid Date'
        const isValidDate = !isNaN(date.getTime());

        return isValidDate ? null : { invalidInputForType: { type: 'date', message: 'Value must be valid date' } };
    };
}

export function typeValidator(type: 'date' | 'numeric'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        return type === 'date' ? dateValidator()(control) : isNumeric(control)(control);
    };
}
